import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { InstitutionService } from 'src/app/shared/services/institution.service';
import { MediaService } from 'src/app/shared/services/media/media.service';
import { ThemeColor, ThemeService } from 'src/app/shared/services/theme/theme.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent implements OnInit, AfterViewInit, OnDestroy {
  subscription: Subscription = new Subscription()

  title: string = "";
  welcomeMsg: string = "";
  logoUrl?: string

  constructor(
    private institutionService: InstitutionService,
    private themeService: ThemeService,
    private mediaService: MediaService,
    private translateService: TranslateService
  ) { /* do nothing */ }

  ngOnInit(): void {
    this.title = this.translateService.instant("Welcome");
    this.welcomeMsg = this.translateService.instant("welcomePageSecondaryMessage");
  }

  ngAfterViewInit(): void {
    this.subscription.add(this.institutionService.getInstitution().subscribe(institution => {
      this.themeService.setTheme(institution as ThemeColor);
      if (!institution.activateWelcomePage) {
        this.title = institution.welcomePagePrimaryMessage?.find(it => it.code === this.translateService.currentLang).value
        this.welcomeMsg = institution.welcomePageSecondaryMessage?.find(it => it.code === this.translateService.currentLang).value
      }
      this.subscription.add(this.mediaService.getMedia(institution.logoMediaId).subscribe(media => this.logoUrl = media.url))
    }))
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
